import messages from './MLSearchTypesService.messages';

const SEARCH_TYPE_ACCT_NAME = 'acctname';
const SEARCH_TYPE_POLICY = 'policy';
const SEARCH_TYPE_JOB = 'job';
const SEARCH_TYPE_COMP_RATER_QUOTE_NAME = 'CRQN';
const SEARCH_TYPE_COMP_RATER_QUOTE_ID = 'CRQI';
const SEARCH_TYPE_COMP_RATER_JOB_ZIPCODE = 'EQS';

const defaultAvailabilityFn = () => true;

const searchTypes = [
    {
        longName:  messages.name,
        shortName:  messages.name,
        placeholder:  messages.lastNameFirstName,
        maxLength: 255,
        model: 'name_ML',
        code: SEARCH_TYPE_ACCT_NAME,
        isAvailable: defaultAvailabilityFn
    },
    {
        longName:  messages.policy,
        shortName: messages.policy,
        placeholder: messages.policy,
        maxLength: 1333,
        model: 'searchParam',
        code: SEARCH_TYPE_POLICY,
        isAvailable: defaultAvailabilityFn
    },
    {
        longName: messages.submission,
        shortName: messages.submission,
        placeholder: messages.referenceNumber,
        maxLength: 1333,
        model: 'searchParam',
        code: SEARCH_TYPE_JOB,
        isAvailable: defaultAvailabilityFn
    },
    {
        longName: messages.expandedQuoteSearch,
        shortName: messages.EQS,
        placeholder: messages.submission,
        maxLength: 1333,
        model: 'searchParam',
        placeholderSecond: messages.zipCode,
        maxLengthSecond: 9,
        modelSecond: 'zipCode_ML',
        code: SEARCH_TYPE_COMP_RATER_JOB_ZIPCODE,
        isAvailable: () => false
    }
];

export default {
    getSearchTypes() {
        return searchTypes;
    },
    isSearchTypeAcctName(code) {
        return code === SEARCH_TYPE_ACCT_NAME;
    },
    isSearchTypePolicy(code) {
        return code === SEARCH_TYPE_POLICY;
    },
    isSearchTypeJob(code, searchParam) {
        return code === SEARCH_TYPE_JOB && searchParam?.toUpperCase()?.indexOf('HVQ') === -1;
    },
    isSearchTypeCompRaterQuoteName(code) {
        return code === SEARCH_TYPE_COMP_RATER_QUOTE_NAME;
    },
    isSearchTypeCompRaterQuoteID(code, searchParam) {
        return code === SEARCH_TYPE_COMP_RATER_QUOTE_ID || (code === SEARCH_TYPE_JOB && searchParam?.toUpperCase()?.indexOf('HVQ') > -1);
    },
    isSearchTypeCompRaterJobZipcode(code) {
        return code === SEARCH_TYPE_COMP_RATER_JOB_ZIPCODE;
    },
    isSearchByName(code) {
        return code === SEARCH_TYPE_ACCT_NAME || code === SEARCH_TYPE_COMP_RATER_QUOTE_NAME;
    }
};
